import clsx from "clsx";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { to: "/today", icon: "home", label: "Today" },
  { to: "/tasks", icon: "folder_open", label: "Projects" },
  { to: "/activity", icon: "notifications", label: "Alerts" },
  { to: "/settings", icon: "settings", label: "Settings" }
];

export const BottomNav = (): JSX.Element => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="bottom-nav" aria-label="Primary mobile navigation">
      <div className="flex h-14 items-center justify-around">
        {navItems.map((item, index) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              clsx("flex min-h-11 min-w-11 flex-col items-center justify-center text-[11px]", {
                "text-[var(--accent-primary)]": isActive,
                "text-[var(--text-tertiary)]": !isActive
              })
            }
          >
            <span className="material-symbols-outlined text-[22px]">{item.icon}</span>
            <span>{item.label}</span>
            {index === 2 && location.pathname === "/activity" ? (
              <span className="absolute -mt-7 ml-5 inline-block h-2 w-2 rounded-full bg-[var(--status-blocker)]" />
            ) : null}
          </NavLink>
        ))}
      </div>
      <button className="fab" type="button" aria-label="Add task" onClick={() => navigate("?sheet=add-task")}> 
        <span className="material-symbols-outlined text-3xl">add</span>
      </button>
    </nav>
  );
};
